export function parseDate(input, format) {
	format = format || 'yyyy-mm-dd'; // default format
	const parts = input.match(/(\d+)/g);
	const fmt = {};
	let i = 0;
	// extract date-part indexes from the format
	format.replace(/(yyyy|dd|mm)/g, function(part) {
		fmt[part] = i++;
	});

	return new Date(parts[fmt['yyyy']], parts[fmt['mm']] - 1, parts[fmt['dd']]);
}
